import { User } from 'types/users.types';
import { ActiveUserProducer } from 'types/types.type';
import { NullActiveProducer } from 'helpers/ActiveUserProducer/NullActiveProduder';
import { AgentActiveProducer } from 'helpers/ActiveUserProducer/AgentActiveProducer';
import { SupportActiveProducer } from 'helpers/ActiveUserProducer/SupportActiveProducer';
import { Organization } from 'types/organization.type';
import {
    getIsAdminRole,
    getIsAuditRepRole,
    getIsCarrierRepRole,
    getIsLumenRole,
    getIsUnderwriterRole,
} from 'helpers/roles';
import { LumenActiveUserProducer } from 'helpers/ActiveUserProducer/LumenActiveUserProducer';
import { CarrierRepActiveProducer } from 'helpers/ActiveUserProducer/CarrierRepActiveProducer';
import { LumenUnderwriterActiveUserProducer } from './LumenUnderwriterActiveUserProducer';

function getIsProducerAgent(activeProducer: Organization | undefined) {
    return activeProducer && activeProducer.isLicensedAgent;
}

export function createActiveUserProducer(activeUser: User, topUserGroup: string): ActiveUserProducer {
    // TODO: if/when we support users associated with more than one producer OU this becomes some sort of UI selection
    const activeProducer =
        activeUser.organizationalUnits &&
        activeUser.organizationalUnits.find((o) => o.id === activeUser.organizationId);

    let ret: ActiveUserProducer = new NullActiveProducer();

    if (getIsCarrierRepRole(topUserGroup) || getIsAuditRepRole(topUserGroup)) {
        ret = new CarrierRepActiveProducer();
    } else if (getIsAdminRole(topUserGroup) || getIsUnderwriterRole(topUserGroup)) {
        ret = new LumenUnderwriterActiveUserProducer();
    } else if (getIsLumenRole(topUserGroup)) {
        // any non-agents are currently Lumen Users
        ret = new LumenActiveUserProducer();
    } else if (getIsProducerAgent(activeProducer) && activeProducer) {
        ret = new AgentActiveProducer(activeProducer);
    } else if (activeProducer) {
        ret = new SupportActiveProducer(activeProducer);
    } else {
        // return an ActiveUserProducer object that represents a user not associated with an org
        return ret;
    }
    return ret;
}

// This is not related to the active producer context (used to create a submission, etc), but rather getting a relevant ActiveProducer object for a given producer
// This is used in the submission details page to get the relevant producer for the submission in order to encapsulate logic for different producer types
export function getProducer(orgProducer: Organization) {
    let ret: ActiveUserProducer;
    if (getIsProducerAgent(orgProducer)) {
        ret = new AgentActiveProducer(orgProducer);
    } else {
        ret = new SupportActiveProducer(orgProducer);
    }
    return ret;
}
